import { Spin } from 'antd';
import './index.less';

function PageLoading(props) {
  return (
    <div className="sc-page-loading">
      <Spin size="large" tip={props.tip || ''}>
        <></>
      </Spin>
    </div>
  );
}
export default PageLoading;
